import { render } from "./LuNavbarItem.vue?vue&type=template&id=73aa604c&ts=true"
import script from "./LuNavbarItem.vue?vue&type=script&lang=ts"
export * from "./LuNavbarItem.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\fr5673mo\\Documents\\git.lu.se\\.net\\student-portal\\student-portal-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__